import { render, staticRenderFns } from "./chat-component.vue?vue&type=template&id=29f4cc61&scoped=true"
import script from "./chat-component.vue?vue&type=script&lang=js"
export * from "./chat-component.vue?vue&type=script&lang=js"
import style0 from "./chat-component.vue?vue&type=style&index=0&id=29f4cc61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f4cc61",
  null
  
)

export default component.exports